import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.21 Ce NU-ți promitem (credibilitate) ── */
export function HomeNotUs() {
  const c = useSectionContent("home_not_us");
  const promises = [
    { d: "Nu-ți promit vindecare peste noapte. Drumul e real, și are ritmul lui.", f: "promise1" },
    { d: "Nu-ți vând miracole, nici „secrete” care schimbă totul dintr-o ședință.", f: "promise2" },
    { d: "Nu-ți vând și nu dau nimănui datele tale. Niciodată.", f: "promise3" },
    { d: "Nu te judec pentru unde ești acum. Ai ajuns aici cum ai putut.", f: "promise4" },
  ];
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-2xl mx-auto px-5 text-center">
        <ShieldCheck size={28} className="mx-auto mb-4" style={{ color: "var(--ct-link)" }} />
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Onest, de la început"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-6">{c.title || "Ce NU-ți promit"}</h2>
        <div className="space-y-3 text-left max-w-md mx-auto">
          {promises.map((p) => (
            <div key={p.f} className="flex items-start gap-3 p-3 rounded-xl" style={{ background: "var(--ct-bg)" }}>
              <span style={{ color: "var(--ct-gold)" }}>—</span>
              <p data-el="item_body" data-field={p.f} className="text-sm" style={{ color: "var(--ct-text-muted)" }}>{c[p.f] || p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
